import React, { Component } from 'react';
import SecureLayout from '../../../templates/secure';
import {NavLink} from 'react-router-dom';
//import _ from 'lodash';

class SurveysAdd extends Component{
	render(){
		//const {goals} =this.props;
		//let gc = _.find(goals.permissions, (o) => {return o==='Create'});
		return (
			<p>
				<NavLink to={`/encuestas/crear`} className="button is-small is-inm-purple">{'Agregar encuesta'}</NavLink>
			</p>
		)
	}
}

export default SecureLayout(SurveysAdd);


// WEBPACK FOOTER //
// ./src/elements/surveys/widget/surveys_add.jsx